import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { fetchCmsItems, getOptimizedImageUrl } from '../lib/cms'
import InquiryModal from '../components/InquiryModal'

export default function TravelTypesPage() {
  const [travelTypes, setTravelTypes] = useState([])
  const [modalOpen, setModalOpen] = useState(false)

  useEffect(() => {
    document.title = 'Rejsetyper - SKI & CO TRAVEL ApS'
    async function loadTypes() {
      const data = await fetchCmsItems('rejsetyper')
      setTravelTypes(data)
    }
    loadTypes()
  }, [])

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 py-12 space-y-12">
      <div className="space-y-3">
        <span className="text-xs font-bold uppercase tracking-widest text-cyan-400">
          SKI & CO TRAVEL ApS
        </span>
        <h1 className="font-heading font-extrabold text-2xl sm:text-4xl text-white">
          Skirejser for enhver smag
        </h1>
        <p className="text-slate-300 text-sm sm:text-base max-w-2xl leading-relaxed">
          Hvad enten I rejser som familie med skiskolebørn, vennegruppe på udkig efter luksus og spa, gourmetentusiaster eller en stor virksomhed, skræddersyr vi den perfekte skiferie.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
        {travelTypes.map((type) => {
          const imageUrl = Array.isArray(type.hovedbillede)
            ? type.hovedbillede[0]
            : type.hovedbillede

          return (
            <div
              key={type.id}
              className="bg-slate-900 border border-slate-800 rounded-3xl overflow-hidden shadow-2xl flex flex-col justify-between"
            >
              <div className="relative h-64 overflow-hidden">
                <img
                  src={getOptimizedImageUrl(imageUrl, 800, 80)}
                  alt={type.navn}
                  className="w-full h-full object-cover"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-slate-900 via-slate-900/40 to-transparent" />
                <div className="absolute bottom-4 left-6 right-6">
                  <h2 className="font-heading font-extrabold text-2xl text-white">
                    {type.navn}
                  </h2>
                </div>
              </div>

              <div className="p-6 sm:p-8 space-y-6">
                {type.beskrivelse && (
                  <div
                    className="prose prose-invert text-slate-300 text-sm leading-relaxed"
                    dangerouslySetInnerHTML={{ __html: type.beskrivelse }}
                  />
                )}

                <div className="pt-4 border-t border-slate-800 flex items-center justify-between gap-4">
                  <Link
                    to="/skirejser"
                    className="px-5 py-2.5 rounded-xl bg-cyan-500 hover:bg-cyan-400 text-slate-950 font-bold text-xs uppercase tracking-wider transition-colors inline-flex items-center gap-2"
                  >
                    <span>Se relevante rejser</span>
                    <i className="fa-solid fa-arrow-right" aria-hidden="true" />
                  </Link>

                  <button
                    onClick={() => setModalOpen(true)}
                    className="text-slate-300 hover:text-cyan-400 text-xs font-semibold transition-colors"
                  >
                    Send forespørgsel &rarr;
                  </button>
                </div>
              </div>
            </div>
          )
        })}
      </div>

      <InquiryModal isOpen={modalOpen} onClose={() => setModalOpen(false)} />
    </div>
  )
}
